import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import { EmployeeTaxasManager } from './EmployeeTaxasManager';

export interface EmployeeTaxasDialogProps {
  open: boolean;
  employeeId: number | null;
  employeeName?: string;
  onClose: () => void;
}

/**
 * Wrapper Dialog descartável em torno de `EmployeeTaxasManager`. Mesmo pattern
 * dos endereços (`CompanyAddressesDialog`/`ClientAddressesDialog`). Se um dia
 * fizer sentido página dedicada, basta envolver o Manager com `<PageHeader>`.
 */
export function EmployeeTaxasDialog({
  open,
  employeeId,
  employeeName,
  onClose,
}: EmployeeTaxasDialogProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {employeeName
          ? t('features.colaboradores.taxas.dialogTitleNamed', { nome: employeeName })
          : t('features.colaboradores.taxas.dialogTitle')}
        <IconButton onClick={onClose} aria-label={t('common.close')} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {employeeId !== null && <EmployeeTaxasManager employeeId={employeeId} />}
      </DialogContent>
    </Dialog>
  );
}
